import { ServiceSessionStorageBase } from "@/services/storage/base/service-session-storage-base";
import { SelectedTabHandler } from "@/services/storage/base/storage-abstractions";

export class SelectedTabStorageMixin<T>
  extends ServiceSessionStorageBase
  implements SelectedTabHandler<T>
{
  private readonly selectedFileTabKey = "selectedConvertFileTab";

  public async setSelectedFileTab<T>(tab: T): Promise<void> {
    await this.saveDataDB(this.selectedFileTabKey, tab);
  }

  public async getSelectedFileTab<T>(): Promise<T | null> {
    const selectedTab = (await this.getDataDB(this.selectedFileTabKey)) as T;
    if (!selectedTab) {
      return null;
    }

    return selectedTab;
  }
}
